import { View, Text, Image, TouchableOpacity } from 'react-native';
import colors from '@/constants/Colors';
import { useSupabase } from '@/hooks/useSupabase';
import { trpc } from '@/trpc/react';

export default function HoldingScreen() {
  const { signOut, user } = useSupabase();
  const { refetch } = trpc.crew.getByUserId.useQuery(
    { user_id: user?.id! },
    { enabled: !!user?.id }
  );

  const handleRefresh = async () => {
    await refetch();
  };

  return (
    <View style={{
      flex: 1,
      backgroundColor: colors.background,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20
    }}>
      <Image
        source={require("@/assets/images/new-logo.png")}
        style={{
          width: 150,
          height: 285,
          marginBottom: 40,
          opacity: 0.9
        }}
      />
      <Text style={{
        fontSize: 16,
        textAlign: 'center'
      }}>
        Thank you for signing up to the new Crewsaders app.
      </Text>
      <Text style={{
        fontSize: 16,
        textAlign: 'center',
        marginTop: 16
      }}>
        Please continue to use the current app until contacted by the Office Team.
      </Text>

      {/* Buttons Container */}
      <View style={{
        flexDirection: 'row',
        marginTop: 40,
        gap: 16
      }}>
        <TouchableOpacity
          onPress={handleRefresh}
          style={{
            backgroundColor: colors.accent,
            paddingHorizontal: 24,
            paddingVertical: 12,
            borderRadius: 8,
          }}
        >
          <Text style={{
            color: colors.primary,
            fontSize: 16,
            fontWeight: '600'
          }}>
            Refresh
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() => signOut({ clearBiometric: true })}
          style={{
            backgroundColor: colors.error,
            paddingHorizontal: 24,
            paddingVertical: 12,
            borderRadius: 8,
          }}
        >
          <Text style={{
            color: 'white',
            fontSize: 16,
            fontWeight: '600'
          }}>
            Sign Out
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
} 